import React, { useState, useEffect } from 'react';
import { TextField, Tooltip } from '@common-ui/ui';

const DatePicker = React.memo(
  ({ id, name, label, value, onChange = null, onBlur = null, disabled = false }) => {
    const [selectedDate, setSelectedDate] = useState('');

    useEffect(() => {
      // refer to ISO 8601
      // String value = 'YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS PM'
      let date = (value || '').split(' ')[0];
      setSelectedDate(date);
    }, [value]);

    const handleDateChange = (event) => {
      if (onChange) {
        onChange(event);
      } else {
        setSelectedDate(event.target.value);
      }
    };

    return (
      <Tooltip title="Select a date" sx={{ cursor: 'pointer' }}>
        <TextField
          id={id || 'textfield-date-picker'}
          type="date"
          name={name}
          label={label || 'Select a date'}
          value={selectedDate}
          onChange={handleDateChange}
          onBlur={onBlur}
          disabled={disabled}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Tooltip>
    );
  },
);

export default DatePicker;
